'use strict'

import fetch from 'isomorphic-fetch'
import { filter, flatten, uniqBy } from 'lodash'
import { WaitAction } from 'react-aquasys'
import { getJson } from '../../utils/ActionUtils'
import ApplicationConf from '../../conf/ApplicationConf'
import {
	CLOSE_MODAL_SELECTED_SELECTION_DELETE,
	CLOSE_MODAL_SELECTED_SELECTION_EXPORT,
	CLOSE_MODAL_SELECTED_SELECTION_INFORMATION,
	CLOSE_MODAL_SELECTED_SELECTION_SAVE,
	OPEN_MODAL_SELECTED_SELECTION_DELETE,
	OPEN_MODAL_SELECTED_SELECTION_EXPORT,
	OPEN_MODAL_SELECTED_SELECTION_INFORMATION,
	OPEN_MODAL_SELECTED_SELECTION_SAVE,
	RECEIVE_ALL_SELECTIONS,
	RECEIVE_AND_SELECT_SELECTION,
	RECEIVE_DELETE_SELECTION,
	RECEIVE_FAVORITE_SELECTION,
	RECEIVE_FILTERS_VALUES,
	RECEIVE_REMOVE_FAVORITE_SELECTION,
	RECEIVE_SELECTED_EXPORT_SELECTIONS,
	RECEIVE_SELECTIONS_DETAIL_SITES,
	RECEIVE_SELECTIONS_EXPORT_HISTORY,
	RECEIVE_SELECTIONS_FILTERS,
	RECEIVE_SELECTIONS_KEY_FIGURES,
	RECEIVE_SELECTIONS_SITES,
	RECEIVE_SELECTIONS_STATUS,
	RECEIVE_SELECTIONS_WATERSHED,
	RESET_SELECTED_EXPORT_SELECTIONS,
	RESET_SELECTED_SELECTION,
	RESET_SELECTION_INFORMATIONS,
	RESET_USER_SELECTION,
	SELECTED_SELECTION
} from '../constants/SelectionConstants'
import { getFetchSiteIds } from '../../utils/ApplicationUtils'
import DtoSelection from '../dto/DtoSelection'
import i18n from 'simple-react-i18n'
import ToastrAction from '../../home/actions/ToastrAction'

const SelectionAction = {

	receiveSelections: function (selections) {
		return {
			type: RECEIVE_ALL_SELECTIONS,
			selections: selections
		}
	},

	fetchSelection: (selectionname, login) => dispatch => {
		return fetch(ApplicationConf.selection.getSelectionByName(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/vnd.pgrst.object+json'
			},
			body: JSON.stringify({ selectionname, login })
		})
			.then(getJson)
			.then((json = {}) => {
				if (json.id) {
					dispatch(SelectionAction.updateSelections(json))
					dispatch(SelectionAction.setSelectedSelection(new DtoSelection(json)))
				}
				return json
			}).then(json => {
				if (json.id) {
					Promise.all([SelectionAction.fetchSelectionSites([json.id])]).then(v => {
						const idSelections = flatten(v)
						dispatch(SelectionAction.receiveSelectionSites(idSelections))
						const idSites = idSelections.map(o => o.site_id)
						Promise.all([SelectionAction.fetchSelectionDetailSites(idSites)]).then(c => {
							const siteIds = flatten(c)
							dispatch(SelectionAction.receiveSelectionDetailSites(siteIds))
						})
						Promise.all([SelectionAction.fetchSelectionKeyFigures(idSites)]).then(c => {
							const selectionKeyfigures = flatten(c)
							dispatch(SelectionAction.receiveSelectionKeyFigures(selectionKeyfigures))
						})
					})
					dispatch(SelectionAction.fetchSelectionFilters([json.id]))
					return json.id
				}
				return null
			}).then(id => {
				if (id) {
					dispatch(SelectionAction.fetchSelectionExportHistory([id]))
					dispatch(SelectionAction.fetchSelectionWatershed([id]))
				}
			}).catch(() => {
				dispatch(ToastrAction.error(i18n.error.cannotGetSelection))
			})
	},

	updateSelections: selection => {
		return { type: RECEIVE_AND_SELECT_SELECTION, selection }
	},

	fetchSelections: function (login) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.selection.get(login), {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json'
				}
			})
				.then(getJson)
				.then((jsonResult = []) => {
					if (jsonResult.length) {
						const filterSelectionClose = filter(jsonResult, (o) => {
							return !o.closedate && !o.close
						})
						const ids = filterSelectionClose.map(o => o.id)
						Promise.all([SelectionAction.fetchSelectionSites(ids)]).then((values) => {
							const idSelections = uniqBy(flatten(values))
							const idSites = idSelections.map((o) => {
								return o.site_id
							})
							Promise.all([SelectionAction.fetchSelectionDetailSites(idSites)]).then((c) => {
								const siteIds = flatten(c)
								dispatch(SelectionAction.receiveSelectionDetailSites(siteIds))
							})
							Promise.all([SelectionAction.fetchSelectionKeyFigures(idSites)]).then((c) => {
								const selectionKeyfigures = flatten(c)
								dispatch(SelectionAction.receiveSelectionKeyFigures(selectionKeyfigures))
							})
							dispatch(SelectionAction.receiveSelectionSites(idSelections))
						})
						dispatch(SelectionAction.fetchSelectionFilters(ids))
						dispatch(SelectionAction.receiveSelections(filterSelectionClose))
						return ids
					}
					return null
				}).then((idsSelection) => {
					if (idsSelection) {
						dispatch(SelectionAction.fetchSelectionExportHistory(idsSelection))
						dispatch(SelectionAction.fetchSelectionWatershed(idsSelection))
					}
				}).then(() => {
					dispatch(WaitAction.waitStop())
				}).catch(() => {
					dispatch(ToastrAction.error(i18n.error.cannotGetSelection))
					dispatch(WaitAction.waitStop())
				})
		}
	},


	updateExecution(id, login) {
		return function (dispatch) {
			return fetch(ApplicationConf.selection.updateExecution(id), {
				method: 'PUT',
				headers: { authorization: btoa('Basic ' + login) }
			})
				.then(() => {
				}).catch((error) => {
					dispatch(ToastrAction.error(error))
				})
		}
	},

	receiveSelectionSites: function (selectionSites) {
		return {
			type: RECEIVE_SELECTIONS_SITES,
			selectionSites: selectionSites
		}
	},
	fetchSelectionSites: function (idSelections) {
		return fetch(ApplicationConf.selection.getSelectionSites(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ selectionids: getFetchSiteIds(idSelections) })
		})
			.then(getJson)
			.then((json = []) => {
				if (!json.error) {
					return json
				}
				return []
			})
	},
	receiveSelectionFilters: function (selectionFilters) {
		return {
			type: RECEIVE_SELECTIONS_FILTERS,
			selectionFilters: selectionFilters
		}
	},
	fetchSelectionFilters: function (idSelections) {
		return function (dispatch) {
			return fetch(ApplicationConf.selection.getSelectionFilters(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ selectionids: getFetchSiteIds(idSelections) })
			})
				.then(getJson)
				.then((json = []) => {
					dispatch(SelectionAction.receiveSelectionFilters(json))
					return json
				}).then((json) => {
					const filterIds = json.map(o => o.id)
					dispatch(SelectionAction.fetchFilterValues(filterIds))
				})
		}
	},

	receiveFilterValues: function (filterValues) {
		return {
			type: RECEIVE_FILTERS_VALUES,
			filterValues: filterValues
		}
	},
	fetchFilterValues: function (filterIds) {
		return function (dispatch) {
			return fetch(ApplicationConf.selection.getFilters(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ filterids: getFetchSiteIds(filterIds) })
			})
				.then(getJson)
				.then((json = []) => {
					dispatch(SelectionAction.receiveFilterValues(json))
					return json
				})
		}
	},
	receiveSelectionDetailSites: function (selectionDetailsSites) {
		return {
			type: RECEIVE_SELECTIONS_DETAIL_SITES,
			selectionDetailsSites: selectionDetailsSites
		}
	},
	fetchSelectionDetailSites: function (siteIds) {
		return fetch(ApplicationConf.selection.getSites(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(
				{
					sitesid: getFetchSiteIds(siteIds)
				})
		})
			.then(getJson)
			.then((json = []) => {
				if (!json.error) {
					return json
				}
				return []
			})
	},

	resetSelection: function () {
		return {
			type: RESET_USER_SELECTION
		}
	},

	setSelectedSelection: function (selectedSelection) {
		return {
			type: SELECTED_SELECTION,
			selectedSelection: selectedSelection
		}
	},

	resetSelectedSelection: function () {
		return {
			type: RESET_SELECTED_SELECTION
		}
	},

	saveSelection: function (login, name, filters, stations, watersheds) {
		const result = SelectionAction.formatJson(name, filters, stations, watersheds)
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.selection.selectionsPath(), {
				method: 'POST',
				headers: { authorization: btoa('Basic ' + login) },
				body: JSON.stringify(result)
			})
				.then(() => {
					dispatch(ToastrAction.success(i18n.addNewSelectionSuccess))
				}).then(() => {
					dispatch(SelectionAction.fetchSelection(name, login))
					dispatch(SelectionAction.fetchSelections(login))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				}).catch((error) => {
					dispatch(ToastrAction.error(error))
					dispatch(WaitAction.waitStop())
				})
		}
	},

	updateSelection: function (selectionId, login, name, filters, stations, watersheds) {
		const result = SelectionAction.formatJson(name, filters, stations, watersheds)
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			//dispatch(SelectionAction.resetSelectionInformations(selectionId))
			return fetch(ApplicationConf.selection.selectionPath(selectionId), {
				method: 'PUT',
				headers: { authorization: btoa('Basic ' + login) },
				body: JSON.stringify(result)
			})
				.then(() => {
					dispatch(ToastrAction.success(i18n.savedSelection))
				}).then(() => {
					dispatch(SelectionAction.fetchSelections(login))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				}).catch((error) => {
					dispatch(ToastrAction.error(error))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	resetSelectionInformations: function (selectionId) {
		return {
			type: RESET_SELECTION_INFORMATIONS,
			selectionId: selectionId
		}
	},
	receiveDeleteSelection: function (selectionId) {
		return {
			type: RECEIVE_DELETE_SELECTION,
			selectionId: selectionId
		}
	},

	deleteSelection: function (login, id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			dispatch(SelectionAction.closeModalSelectionDelete())
			return fetch(ApplicationConf.selection.selectionPath(id), {
				method: 'DELETE',
				headers: { authorization: btoa('Basic ' + login) }
			})
				.then(() => {
					dispatch(ToastrAction.success(i18n.deletedSelection))
				}).then(() => {
					dispatch(SelectionAction.receiveDeleteSelection(id))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				}).catch((error) => {
					dispatch(ToastrAction.error(error))
					dispatch(WaitAction.waitStop())
				})
		}
	},

	receiveSelectionKeyFigures: function (selectionKeyFigures) {
		return {
			type: RECEIVE_SELECTIONS_KEY_FIGURES,
			selectionKeyFigures: selectionKeyFigures
		}
	},
	fetchSelectionKeyFigures: function (stationIds) {
		return fetch(ApplicationConf.sites.getKeyFigures(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(
				{
					stationids: getFetchSiteIds(stationIds)
				})
		})
			.then(getJson)
			.then((json = []) => {
				if (!json.error) {
					return json
				}
				return []
			})
	},

	receiveSelectionExportHistory: function (selectionExportsHistory) {
		return {
			type: RECEIVE_SELECTIONS_EXPORT_HISTORY,
			selectionExportsHistory: selectionExportsHistory
		}
	},
	fetchSelectionExportHistory: function (selectionIds) {
		return function (dispatch) {
			return fetch(ApplicationConf.selection.getExportHistory(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						selectionids: getFetchSiteIds(selectionIds)
					})
			})
				.then(getJson)
				.then((json = []) => {
					dispatch(SelectionAction.receiveSelectionExportHistory(json))
				})
		}
	},
	receiveSelectionWatershed: function (selectionWatershed) {
		return {
			type: RECEIVE_SELECTIONS_WATERSHED,
			selectionWatershed: selectionWatershed
		}
	},
	fetchSelectionWatershed: function (selectionIds) {
		return function (dispatch) {
			return fetch(ApplicationConf.selection.getSelectionWatershed(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						selectionids: getFetchSiteIds(selectionIds)
					})
			})
				.then(getJson)
				.then((json = []) => {
					dispatch(SelectionAction.receiveSelectionWatershed(json))
				})
		}
	},
	receiveSelectionStatus: function (selectionStatus) {
		return {
			type: RECEIVE_SELECTIONS_STATUS,
			selectionStatus: selectionStatus
		}
	},
	fetchSelectionStatus: function () {
		return function (dispatch) {
			return fetch(ApplicationConf.selection.status(), {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json'
				}
			})
				.then(getJson)
				.then((json = []) => {
					dispatch(SelectionAction.receiveSelectionStatus(json))
				})
		}
	},
	receiveFavoriteSelection: function (selectionId) {
		return {
			type: RECEIVE_FAVORITE_SELECTION,
			selectionId: selectionId
		}
	},
	setFavoriteSelection(selection) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.selection.addFavorite(selection.id), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					authorization: btoa('Basic ' + atob(sessionStorage.getItem('TOKEN')))
				}
			})
				.then(() => {
					dispatch(WaitAction.waitStop())
					dispatch(SelectionAction.receiveFavoriteSelection(selection.id))
				})
				.catch(() => {
					dispatch(ToastrAction.error('Error save favorite'))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	receiveRemoveFavoriteSelection: function (selectionId) {
		return {
			type: RECEIVE_REMOVE_FAVORITE_SELECTION,
			selectionId: selectionId
		}
	},
	removeFavoriteSelection(selection) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.selection.removeFavorite(selection.id), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					authorization: btoa('Basic ' + atob(sessionStorage.getItem('TOKEN')))
				}
			}).then(() => {
				dispatch(WaitAction.waitStop())
				dispatch(SelectionAction.receiveRemoveFavoriteSelection(selection.id))
			}).catch(() => {
				dispatch(ToastrAction.error('Error remove favorite'))
				dispatch(WaitAction.waitStop())
			})
		}
	},
	receiveSelectedExportSelection: function (selectedExportSelections) {
		return {
			type: RECEIVE_SELECTED_EXPORT_SELECTIONS,
			selectedExportSelections: selectedExportSelections
		}
	},
	resetSelectedExportSelection: function () {
		return {
			type: RESET_SELECTED_EXPORT_SELECTIONS
		}
	},
	openModalSelectionInformation: function (selectedSelectionInformation) {
		return {
			type: OPEN_MODAL_SELECTED_SELECTION_INFORMATION,
			selectedSelectionInformation: selectedSelectionInformation
		}
	},
	openModalSelectionDelete: function (selectedSelectionInformation) {
		return {
			type: OPEN_MODAL_SELECTED_SELECTION_DELETE,
			selectedSelectionInformation: selectedSelectionInformation
		}
	},
	openModalSelectionExport: function (selectedSelectionInformation) {
		return {
			type: OPEN_MODAL_SELECTED_SELECTION_EXPORT,
			selectedSelectionInformation: selectedSelectionInformation
		}
	},
	openModalSelectionSave: function () {
		return {
			type: OPEN_MODAL_SELECTED_SELECTION_SAVE
		}
	},
	closeModalSelectionInformation: function () {
		return {
			type: CLOSE_MODAL_SELECTED_SELECTION_INFORMATION
		}
	},
	closeModalSelectionDelete: function () {
		return {
			type: CLOSE_MODAL_SELECTED_SELECTION_DELETE
		}
	},
	closeModalSelectionExport: function () {
		return {
			type: CLOSE_MODAL_SELECTED_SELECTION_EXPORT
		}
	},
	closeModalSelectionSave: function () {
		return {
			type: CLOSE_MODAL_SELECTED_SELECTION_SAVE
		}
	},

	exportSelection: function (login, selectionId, selectedOptions = []) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.selection.export(selectionId), {
				method: 'POST',
				headers: { authorization: btoa('Basic ' + login) },
				body: JSON.stringify(
					{
						exportType: selectedOptions
					})
			})
				.then(() => {
					dispatch(WaitAction.waitStop())
					dispatch(ToastrAction.success(i18n.receiveEmailDownloadLink))
				}).then(() => {
					dispatch(SelectionAction.closeModalSelectionExport())
				}).catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorOccurredExportingSelection))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	exportSelections: function (login, listOfSelections) {
		return function (dispatch) {
			if (listOfSelections.length > 1) {
				dispatch(ToastrAction.info('L\'export de plusieurs sélections est en développement'))
			} else {
				dispatch(SelectionAction.exportSelection(login, listOfSelections[0].id))
			}
			dispatch(SelectionAction.resetSelectedExportSelection())
		}
	},
	formatJson: function (name, filterValue, stations, watersheds) {
		const ids = stations.map((o) => {
			return o.id
		})
		const watershedIds = watersheds.map((o) => {
			return o.id
		})
		const filters = filterValue.map((o) => {
			return {
				type: o.filterTypeId,
				value: o.value
			}
		})
		return {
			name: name,
			selectedSites: ids,
			filters: filters,
			watershed: watershedIds
		}
	}
}

export default SelectionAction



// WEBPACK FOOTER //
// ./src/dashboard/actions/SelectionAction.js